export class SignedPlayerInfo {
  // Required for all platforms
  platform: string;
  /** An optional developer specified payload provided during the request */
  payload: string;
  /** The players unique identifier on the platform */
  playerId: string;
  /** The player's authentication token signature */
  signature: string;

  constructor() {
    this.platform = '';
    this.payload = '';
    this.playerId = '';
    this.signature = '';
  }

  fromFacebookData(
    data: FBInstant.SignedPlayerInfo,
    requestPayload: string,
  ): SignedPlayerInfo {
    this.platform = 'fb';
    this.payload = requestPayload || '';
    this.playerId = data.getPlayerID();
    this.signature = data.getSignature();
    return this;
  }

  fromLineData(data: {
    idToken: string;
    payload: string;
    playerId: string;
  }): SignedPlayerInfo {
    this.platform = 'line';
    this.payload = data.payload;
    this.playerId = data.playerId;
    this.signature = data.idToken;
    return this;
  }

  fromLinkData(
    data: {
      getPlayerID: () => string;
      getSignature: () => string;
    },
    requestPayload?: string,
  ): this {
    this.platform = 'link';
    this.payload = requestPayload || '';
    this.playerId = data.getPlayerID();
    this.signature = data.getSignature();
    return this;
  }

  fromSnapchatData(data: {
    playerID: string;
    payload: string;
    token: string;
  }): SignedPlayerInfo {
    this.platform = 'snapchat';
    this.playerId = data.playerID;
    this.payload = data.payload;
    this.signature = data.token;
    return this;
  }

  fromViberData(
    data: {
      getPlayerID: () => string;
      getSignature: () => string;
    },
    requestPayload?: string,
  ): SignedPlayerInfo {
    this.platform = 'viber';
    this.payload = requestPayload || '';
    this.playerId = data.getPlayerID();
    this.signature = data.getSignature();
    return this;
  }

  fromZoomData(data: {
    idToken: string;
    payload: string;
    playerId: string;
  }): SignedPlayerInfo {
    this.platform = 'zoom';
    this.payload = data.payload;
    this.playerId = data.playerId;
    this.signature = data.idToken;
    return this;
  }
}
